<template>
    <div class="w-100 pt-2">
        <button type="button"
        style="gap: .5rem;"
        :style="[bgColor || outlined ? (bgColor && !outlined ? {'background-color': bgColor} : {'border-color': bgColor, 'color': bgColor, 'background-color': 'transparent'}) : '']"
        :class="[!bgColor && !outlined ? btnVariant : '', 'btn', 'rounded-4', 'w-100', 'text', 'btn--shadow']"
        v-on:click="onClick">
            <i v-if="icon" :class="icon"></i>
            {{ text }}
        </button>
    </div>
</template>

<script>
export default {
  name: 'defaultButton',
  props: {
    text: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    onClick: {
      type: Function,
      default: function () {}
    },
    btnVariant: {
      type: String,
      default: null
    },
    outlined: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: null
    },
    customStyle: {
      type: String,
      default: null
    }
  }
}
</script>
<style lang="scss">
    .btn--shadow{
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: 100%;
        letter-spacing: -0.28px;
        text-transform: uppercase;

        display: flex;
        justify-content: space-between;
    }

    .default__btn{
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.10);
    }
</style>



// WEBPACK FOOTER //
// src/components/UI/button/defaultButton.vue